import * as React from "react";
import { tokens, makeStyles } from "@fluentui/react-components";

export interface HeroListItem {
  icon: React.JSX.Element;
  primaryText: string;
  seccondaryText: string;
}

export interface HeroListProps {
  message: string;
  items: HeroListItem[];
}

const useStyles = makeStyles({
  list: {
    marginTop: "20px",
    paddingLeft: "20px",
    paddingRight: "20px",
  },
  listItem: {
    paddingBottom: "5px",
    display: "flex",
    alignItems: "start",
  },
  icon: {
    marginRight: "10px",
    marginTop: "3px",
    fontSize: tokens.fontSizeBase400,
    color: tokens.colorBrandForeground1,
  },
  itemText: {
    fontSize: tokens.fontSizeBase300,
    fontColor: tokens.colorNeutralBackgroundStatic,
  },
  primaryText: {
    fontSize: tokens.fontSizeBase400,
    marginBottom: "5px",
    marginTop: "0",
    color: tokens.colorBrandForeground1,
  },
  seccondaryText: {
    fontSize: tokens.fontSizeBase300,
    marginTop: "0",
  },
  welcome__main: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  message: {
    fontSize: tokens.fontSizeBase500,
    fontColor: tokens.colorBrandForeground1,
    fontWeight: tokens.fontWeightBold,
    paddingLeft: "10px",
    paddingRight: "10px",
  },
});

const HeroList = (props: HeroListProps) => {
  const { items, message } = props;
  const styles = useStyles();

  const listItems = items.map((item, index) => (
    <li className={styles.listItem} key={index}>
      <i className={styles.icon}>{item.icon}</i>
      <div className={styles.itemText}>
        <p className={styles.primaryText}>
          <strong>{item.primaryText}</strong>
        </p>
        <p className={styles.seccondaryText}>{item.seccondaryText}</p>
      </div>
    </li>
  ));
  return (
    <div className={styles.welcome__main}>
      <p className={styles.message}>{message}</p>
      <ul className={styles.list}>{listItems}</ul>
    </div>
  );
};

export default HeroList;
